(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["exertion-password"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const pad = (n) => String(n).padStart(2, '0');
    const init = (root) => {
      if (root.dataset.xpwReady) return;
      root.dataset.xpwReady = '1';
      const clock = root.querySelector('[data-xpw-clock]');
      const target = Date.parse(root.dataset.target);
      if (!clock || Number.isNaN(target)) return;
      const q = (k) => root.querySelector(k);
      const d = q('[data-xpw-d]'), h = q('[data-xpw-h]'), m = q('[data-xpw-m]'), s = q('[data-xpw-s]');
      let timer;
      const tick = () => {
        let t = Math.max(0, Math.floor((target - Date.now()) / 1000));
        if (t === 0) {
          clock.hidden = true;
          const live = q('[data-xpw-live]');
          if (live) live.hidden = false;
          clearInterval(timer);
          return;
        }
        d.textContent = pad(Math.floor(t / 86400)); t %= 86400;
        h.textContent = pad(Math.floor(t / 3600)); t %= 3600;
        m.textContent = pad(Math.floor(t / 60));
        s.textContent = pad(t % 60);
      };
      timer = setInterval(tick, 1000);
      tick();
    };
    const run = () => document.querySelectorAll('[data-xpw]').forEach(init);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
    document.addEventListener('shopify:section:load', run);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gift-card-builder"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('gift-card-builder')) {
    class GiftCardBuilder extends HTMLElement {
      connectedCallback() {
        this.variants = JSON.parse(this.querySelector('[data-variants]').textContent);
        this.prices = this.variants.map((variant) => variant.price);
        this.min = Math.min(...this.prices);
        this.max = Math.max(...this.prices);
        this.form = this.querySelector('[data-gcb-form]');
        this.variantInput = this.querySelector('[data-variant-input]');
        this.custom = this.querySelector('[data-custom-amount]');
        this.toggle = this.querySelector('[data-recipient-toggle]');
        this.sendOn = this.querySelector('[data-send-on]');

        if (this.sendOn) {
          const today = new Date();
          const later = new Date();
          later.setDate(today.getDate() + 90);
          const iso = (date) => new Date(date.getTime() - date.getTimezoneOffset() * 60000).toISOString().slice(0, 10);
          this.sendOn.min = iso(today);
          this.sendOn.max = iso(later);
        }

        this.querySelectorAll('[data-amount]').forEach((chip) => {
          chip.addEventListener('click', () => {
            if (this.custom) this.custom.value = '';
            this.select(Number(chip.dataset.amount) * 100);
          });
        });

        this.custom?.addEventListener('input', () => {
          const dollars = Number(this.custom.value);
          if (!dollars) return;
          this.select(this.snap(dollars * 100), false);
        });
        this.custom?.addEventListener('change', () => {
          const dollars = Number(this.custom.value);
          if (!dollars) return;
          const cents = this.snap(dollars * 100);
          this.custom.value = cents / 100;
          this.select(cents);
        });

        this.toggle?.addEventListener('change', () => this.setRecipient(this.toggle.checked));
        this.querySelector('[data-recipient-name]')?.addEventListener('input', (event) => {
          const to = this.querySelector('[data-card-to]');
          if (to) to.textContent = event.target.value ? `FOR ${event.target.value}` : '';
        });

        this.form?.addEventListener('submit', (event) => this.validate(event));
        this.select(this.currentPrice());
      }

      snap(cents) {
        const stepped = Math.round(cents / 500) * 500;
        const clamped = Math.min(this.max, Math.max(this.min, stepped));
        return this.prices.reduce((best, price) => (Math.abs(price - clamped) < Math.abs(best - clamped) ? price : best));
      }

      currentPrice() {
        const variant = this.variants.find((v) => String(v.id) === this.variantInput.value);
        return variant ? variant.price : this.prices[0];
      }

      formatMoney(cents) {
        const dollars = cents % 100 === 0 ? String(cents / 100) : (cents / 100).toFixed(2);
        const format = this.dataset.moneyFormat || '${{amount}}';
        return format.replace(/\{\{\s*\w+\s*\}\}/, dollars);
      }

      select(cents, syncChips = true) {
        const variant = this.variants.find((v) => v.price === cents);
        if (!variant) return;
        this.variantInput.value = variant.id;
        const label = this.formatMoney(cents);
        this.querySelector('[data-card-amount]').textContent = label;
        this.querySelector('[data-buy-price]').textContent = label;
        this.querySelector('[data-buy]').disabled = !variant.available;
        this.querySelectorAll('[data-amount]').forEach((chip) => {
          const active = syncChips && Number(chip.dataset.amount) * 100 === cents && !this.custom?.value;
          chip.classList.toggle('is-active', active);
          chip.setAttribute('aria-pressed', String(active));
        });
      }

      setRecipient(on) {
        this.querySelector('[data-recipient]').hidden = !on;
        this.querySelector('[data-self-hint]').hidden = on;
        this.querySelectorAll('[data-recipient-field]').forEach((field) => (field.disabled = !on));
        if (!on) {
          const to = this.querySelector('[data-card-to]');
          if (to) to.textContent = '';
        }
      }

      validate(event) {
        const error = this.querySelector('[data-error]');
        const fail = (message, field) => {
          event.preventDefault();
          error.textContent = message;
          error.hidden = false;
          field?.focus();
        };
        error.hidden = true;
        if (this.custom?.value) {
          const cents = this.snap(Number(this.custom.value) * 100);
          this.custom.value = cents / 100;
          this.select(cents);
        }
        if (this.toggle?.checked) {
          const email = this.querySelector('[data-recipient-email]');
          if (!email.value || !email.checkValidity()) return fail('Add a valid email for the person receiving it.', email);
        }
      }
    }
    customElements.define('gift-card-builder', GiftCardBuilder);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["launch-countdown"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const pad = (n) => String(n).padStart(2, '0');
    const init = (root) => {
      if (root.dataset.xlcReady) return;
      root.dataset.xlcReady = '1';
      const target = Date.parse(root.dataset.target);
      if (Number.isNaN(target)) return;
      const q = (k) => root.querySelector(k);
      const d = q('[data-xlc-d]'), h = q('[data-xlc-h]'), m = q('[data-xlc-m]'), s = q('[data-xlc-s]');
      const tick = () => {
        let t = Math.max(0, Math.floor((target - Date.now()) / 1000));
        if (t === 0) {
          q('[data-xlc-clock]').hidden = true;
          q('[data-xlc-live]').hidden = false;
          const su = q('[data-xlc-signup]');
          if (su) su.hidden = true;
          clearInterval(timer);
          return;
        }
        d.textContent = pad(Math.floor(t / 86400)); t %= 86400;
        h.textContent = pad(Math.floor(t / 3600)); t %= 3600;
        m.textContent = pad(Math.floor(t / 60));
        s.textContent = pad(t % 60);
      };
      const timer = setInterval(tick, 1000);
      tick();
    };
    const run = () => document.querySelectorAll('[data-xlc]').forEach(init);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
    document.addEventListener('shopify:section:load', run);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["manifesto-page"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const run = () => {
      const els = document.querySelectorAll('[data-xmf] .xmf__reveal:not(.is-in)');
      if (!('IntersectionObserver' in window)) { els.forEach((e) => e.classList.add('is-in')); return; }
      const io = new IntersectionObserver((entries) => entries.forEach((e) => {
        if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
      }), { threshold: 0.2 });
      els.forEach((e) => io.observe(e));
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
    document.addEventListener('shopify:section:load', run);
  })();

  } catch(e) { console.error(e); }
})();
})();
